import React, { Component } from 'react';

import NewBook from './Book/NewBook';

class App extends Component {
  render() {
    return (
      <div>
        <NewBook />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js